import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"ma-3",attrs:{"max-width":_vm.getMaxCardWidth(),"tile":"","rounded":""}},[_c(VContainer,[_c(VRow,[_c(VCol,[_c(VImg,{staticClass:"rounded-lg",attrs:{"src":_vm.getImageSource(),"max-height":_vm.getHeight(),"contain":""}})],1)],1),_c(VRow,{staticClass:"ma-1 pt-4 text-h6"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c(VRow,{staticClass:"ma-1"},[_vm._v(" "+_vm._s(_vm.description)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }